/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CopyRule = {
    CopyRrpOnly: 'CopyRrpOnly',
    CopyLpOnly: 'CopyLpOnly',
    CopyRrpAndLp: 'CopyRrpAndLp'
} as const;
export type CopyRule = typeof CopyRule[keyof typeof CopyRule];


export function instanceOfCopyRule(value: any): boolean {
    for (const key in CopyRule) {
        if (Object.prototype.hasOwnProperty.call(CopyRule, key)) {
            if (CopyRule[key as keyof typeof CopyRule] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CopyRuleFromJSON(json: any): CopyRule {
    return CopyRuleFromJSONTyped(json, false);
}

export function CopyRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyRule {
    return json as CopyRule;
}

export function CopyRuleToJSON(value?: CopyRule | null): any {
    return value as any;
}

export function CopyRuleToJSONTyped(value: any, ignoreDiscriminator: boolean): CopyRule {
    return value as CopyRule;
}

